module.exports = __webpack_public_path__ + "img/LV6.f12536c9.webp";